import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureSwiperToggleBanner } from 'mod/featureV2/interface/swiperToggleBanner';
import { FeatureSwiperToggleBanner as ModFeatureSwiperToggleBanner } from 'mod/featureV2/FeatureSwiperToggleBanner';
import styles from './index.module.less';

export function FeatureSwiperToggleBanner(props: IFeatureProps<IFeatureSwiperToggleBanner>): Globals.JSXRenderType {
    return (
        <ModFeatureSwiperToggleBanner
            className={styles['swiper-toggle-banner']}
            {...props}
        />
    )
}

export default FeatureSwiperToggleBanner;